import { Injectable } from "@angular/core";
import { GemsHttpService } from "../../../shared/services/gems-http.service";
import { constants } from "../../../constants/all.constants";
import { Restatement } from "../../../domains/Restatement";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class AaRestatementService {
  constructor(private gemsHttp: GemsHttpService) { }

  loadRestatements(personId) {
    let url = constants.apiRoutes.aaRestatement.restatementsSelect + personId;
    return this.gemsHttp.get(url).pipe(
      map(mapRestatements),
      catchError((err) => {
        console.error("error", err);
        return of([]);
      })
    );
  }

  submitRestatements(obj) {
    //RestatementBatch
    //restatementsPost

    let url = constants.apiRoutes.aaRestatement.restatementsPost;
    return this.gemsHttp.post(url, obj).pipe(
      catchError((err) => {
        console.error("error", err);
        return of([]);
      })
    );
  }

  submitNonRestatements(obj) {
    //RestatementBatch
    //restatementsPost

    let url = constants.apiRoutes.aaRestatement.nonRestatementsPost;
    return this.gemsHttp.post(url, obj).pipe(
      catchError((err) => {
        console.error("error", err);
        return of([]);
      })
    );
  }
}

function mapRestatements(response: any) {
  let data = response.result;
  let documents: Restatement[] = [];
  for (let i = 0; i < data.length; i++) {
    let document: Restatement = {
      DocumentHeaderId: data[i].documentHeaderId,
      AdoptionAgreementId: data[i].adoptionAgreementId,
      AddendumId: data[i].addendumId,
      PlanDocument: data[i].planDocument,
      PlanType: data[i].planType,
      SubgroupId: data[i].subgroupId,
      AddendumDocuments: data[i].addendumDocuments,
      isRestatement: data[i].isRestatement,
    };
    documents.push(document);

    /*     let result = {
        DocumentHeaderId: data.DocumentHeaderId,
        AdoptionAgreementId: data.AdoptionAgreementId,
        AddendumId: data.AddendumId,
        PlanDocument: data.PlanDocument,
        PlanType: data.PlanType,
        SubgroupId: data.SubgroupId,
        AddendumDocuments: data.AddendumDocuments
    }; */
  }

  return documents;
}
